export default () => ({
  couponsUncheckedByUser: [],
  couponsCheckedByUser: [],
  couponsBatchIndex: -1,
});
